import resetSearchStore from '../actions/resetSearchStore';
import getScenarioStore from '../store/getScenarioStore';
import getStore, { createDefaultSearchStore } from '../store/store';
import { getScenarioIdKey } from 'owa-search-next-common';
import { mutator } from 'satcheljs';

mutator(resetSearchStore, actionMessage => {
    // Cache this value because it only gets set on render and needs to persist.
    const isUsing3S = getStore().scenarioStores.get(getScenarioIdKey(actionMessage.scenarioId))
        .isUsing3S;

    // Clear the store.
    getStore().scenarioStores.set(
        getScenarioIdKey(actionMessage.scenarioId),
        createDefaultSearchStore()
    );

    // Reset the isUsing3S value for the next search session.
    getScenarioStore(actionMessage.scenarioId).isUsing3S = isUsing3S;
});
